function ArrayToggle(arr, item) {
    if (arr.includes(item)) {
        while (arr.includes(item)) {
            arr.splice(arr.indexOf(item), 1);
        }
    }
    else {
        arr.push(item);
    }
    return arr;
}
export default ArrayToggle;
